import { createSelector } from 'reselect';

import { academicYearSelectValueSelector } from './academicYearSelectValueSelector';

// Селектор возвращает список учебных годов на основе выбранных в комбике опций
export const chosenAcademicYearsListSelector = createSelector(
  [academicYearSelectValueSelector],
  (academicYearSelectValue) => academicYearSelectValue.map((option) => option.value),
);
